import { Component } from '@angular/core';

@Component({
  selector: 'app-pan-blank-slate',
  templateUrl: './pan-blank-slate.component.html',
  styleUrl: './pan-blank-slate.component.scss',
  standalone: false,
})
export class PanBlankSlateComponent {}
